import { trackMetaPageView } from "./src/common/metaPixel";
import { trackPageView } from "./src/common/analytics";

let lastTrackedGaPagePath = null;

const getPagePath = (location) => {
  if (!location) return null;
  return `${location.pathname || "/"}${location.search || ""}`;
};

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function onInitialClientRender() {
  // Initial render should scroll to top
  window.scrollTo(0, 0);
}

export function shouldUpdateScroll({ routerProps: { location } }) {
  // Whenever route changes, scroll to top
  if (location.action === "PUSH") {
    window.scrollTo(0, 0);
  }
  return false;
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    trackMetaPageView();
  }

  const nextPagePath = getPagePath(location);

  if (!prevLocation) {
    // GA4 config sends the initial page_view. Remember it so this hook does
    // not duplicate that event if Gatsby reports the same route again.
    lastTrackedGaPagePath = nextPagePath;
  } else if (nextPagePath && nextPagePath !== lastTrackedGaPagePath) {
    trackPageView(location);
    lastTrackedGaPagePath = nextPagePath;
  }

  if (location.hash) {
    const id = location.hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      setTimeout(() => {
        const scrollOptions = {
          top: element.offsetTop - 130,
          behavior: prefersReducedMotion() ? "instant" : "smooth",
        };

        window.scrollTo(scrollOptions);
      }, 200);
    }
  } else {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }
};
